import { useEffect, useState } from "react";

const API_BASE_URL = String(process.env.REACT_APP_API_BASE_URL || "/api").replace(/\/$/, "");

export function useCcaVenuePaymentStatus(orderId) {
  const [paymentStatus, setPaymentStatus] = useState("PENDING");
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    const normalizedOrderId = String(orderId || "").trim();
    if (!normalizedOrderId) {
      setPaymentStatus("PENDING");
      setPaymentData(null);
      return undefined;
    }

    let isActive = true;
    let timerId;
    let attempts = 0;

    const checkStatus = async () => {
      attempts += 1;
      try {
        const response = await fetch(
          `${API_BASE_URL}/payments/ccavenue/status/${encodeURIComponent(normalizedOrderId)}`,
          { headers: { Accept: "application/json" } }
        );
        const result = await response.json();
        if (!response.ok || !result?.success) {
          throw new Error("Unable to retrieve payment status.");
        }

        if (!isActive) {
          return;
        }

        const status = String(result.data?.status || "PENDING").toUpperCase();
        setPaymentStatus(["SUCCESS", "FAILED"].includes(status) ? status : "PENDING");
        setPaymentData(result.data || null);

        if (status === "PENDING" && attempts < 40) {
          timerId = window.setTimeout(checkStatus, 3000);
        }
      } catch (_error) {
        if (isActive && attempts < 40) {
          timerId = window.setTimeout(checkStatus, 3000);
        }
      }
    };

    checkStatus();
    return () => {
      isActive = false;
      window.clearTimeout(timerId);
    };
  }, [orderId]);

  return { paymentStatus, paymentData };
}